import { render } from "./eatBindCard.vue?vue&type=template&id=00a84874"
import script from "./eatBindCard.vue?vue&type=script&lang=js"
export * from "./eatBindCard.vue?vue&type=script&lang=js"

import "./eatBindCard.vue?vue&type=style&index=0&id=00a84874&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__